import { render, staticRenderFns } from "./BaseCheckBox.vue?vue&type=template&id=f0841888&scoped=true"
import script from "./BaseCheckBox.vue?vue&type=script&lang=ts"
export * from "./BaseCheckBox.vue?vue&type=script&lang=ts"
import style0 from "./BaseCheckBox.vue?vue&type=style&index=0&id=f0841888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0841888",
  null
  
)

export default component.exports